import { HeaderSearchIcon, IconClose } from '@/assets';
import useCreateQueryString from '@/hooks/useCreateQueryString';
import { Input } from '@nextui-org/react';
import { debounce } from 'lodash';
import { useSearchParams } from 'next/navigation';
import React from 'react';

const ToolbarSearch: React.FC<{
  refSearch: React.RefObject<HTMLInputElement>,
}> = ({ refSearch }) => {
  const searchParam = useSearchParams();
  const createQueryString = useCreateQueryString(); 
  const search = searchParam.get('search') ?? '';
  const onChangeSearch = (text: string) => {
    if (!text && refSearch.current) refSearch.current.value = '';
    createQueryString('search', text, { scroll: false });
  };

  return (
    <div
      className="rounded-[100px] bg-white border-1 border-gray-200 sm:w-full"
    >
      <Input
        classNames={{
          input: ['dark:placeholder:text-white font-normal text-14 pl-1', 'rounded-[100px]'],
          innerWrapper: '!bg-transparent rounded-[100px]',
          inputWrapper:
            '!bg-transparent rounded-[100px] shadow-none h-[40px] sm:h-[36px] sm:min-h-[36px] min-w-[450px] lg:min-w-[260px] sm:w-[100%] sm:min-w-0',
        }}
        onChange={debounce((e) => onChangeSearch(e.target.value), 500)}
        startContent={<HeaderSearchIcon />}
        endContent={
          search ? <IconClose className="cursor-pointer" onClick={() => onChangeSearch('')} /> : null
        }
        ref={refSearch}
        defaultValue={search}
        placeholder="Search in Models"
      />
    </div>
  );
}

export default ToolbarSearch;